import { questionIcon } from '@app/assets';
import { Heading } from '@app/shared/ui/atoms/Common';

interface HeadingWithQuestionIconProps {
  title: string;
  openModal: () => void;
}

export function HeadingWithQuestionIcon({ title, openModal }: HeadingWithQuestionIconProps) {
  return (
    <div className="flex justify-between px-5">
      <Heading level={2}>{title}</Heading>
      <div
        onClick={openModal}
        className="align-center flex size-[30px] cursor-pointer justify-center rounded-full bg-icon"
      >
        <img src={questionIcon} alt="question icon" className="w-3" />
      </div>
    </div>
  );
}
